module.exports = __webpack_public_path__ + "img/symbol_kutschemitpferd@2x.e754dca.webp";